import { getVccTooltipText } from 'app/components/pages/Extranet/ExtranetBookings/common/utils/vccTooltip';
import type { PAX } from 'app/typings/PAX';
import { pluralize } from 'app/utils/strings';

const formatAdults = (adults: number) => pluralize(adults, 'adult', 'adults');

const formatChildren = (children: number) =>
  pluralize(children, 'child', 'children');

const formatBabies = (babies: number) => pluralize(babies, 'baby', 'babies');

export const formatPax = (customer: PAX) => {
  const parts = [];

  if (customer.adults > 0) {
    parts.push(formatAdults(customer.adults));
  }

  if (customer.children > 0) {
    parts.push(formatChildren(customer.children));
  }

  if (customer.babies > 0) {
    parts.push(formatBabies(customer.babies));
  }

  return parts.join(', ');
};

export const getTooltipText = getVccTooltipText;
